import styled from 'styled-components';
import * as antd from 'antd';

export const Wrapper = styled.div`
  margin-bottom: 30px;
`;

export const Label = styled.label`
  margin-bottom: 10px;
`;

export const Spin = styled(antd.Spin)`
  margin-top: 7px;
  margin-bottom: 30px;
`;
